import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import TweenMax from 'gsap/src/uncompressed/TweenMax';
import TimelineMax from 'gsap/src/uncompressed/TimelineMax';

import 'fit-text-webcomponent';
import '../../../src/docReady.js';
import Dom from '../../../src/Dom.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import './style.scss';

const moduleSelector = '.eiovisual-search1';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo search1');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {
    
    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        // Tasks on images
        setTimeout(() => { this.task1(); },0);
    }
    
    // _________________________________________________________________________
    
    /**
     * FIT-TEXT
     * @returns {undefined}
     */
    task1() {
        // seleziona gli elementi fit-text
        let $target = this.$module.querySelectorAll('.fit-text');
        
        // applica fit-text
        $target.forEach(($el,index) => {
            Dom.wrapInner($el,'fit-text');
        });
    }
    

}

// export
export default new Module();